import {createWebHistory, createRouter} from 'vue-router'

import Landing from "./components/pages/Landing.vue";
import Dashboard from "./components/pages/Dashboard.vue";
import Inventory from "./components/pages/Inventory";
import MyCards from "./components/pages/MyCards";
import BoosterShop from "./components/pages/BoosterShop";
import GalleryList from "./components/pages/GalleryList";
import Gallery from "./components/pages/Gallery";
import CardSearch from "./components/pages/CardSearch.vue";
import CardDetailView from "./components/pages/CardDetailView.vue";
import Settings from "./components/pages/Settings.vue";
import DipocacoApp from "./components/pages/DipocacoApp.vue";
import Manage from "./components/pages/Manage.vue";
import Collections from "./components/pages/Collections.vue";
import Collection from "./components/pages/Collection.vue";
import DemoDashboard from "./components/pages/DemoDashboard.vue";
import UserProfile from "./components/pages/UserProfile.vue";
import SocialFeed from "./components/pages/SocialFeed.vue";
import SlotMachine from "./components/pages/SlotMachine.vue";
import CardRoulette from "./components/pages/CardRoulette.vue";
import BoosterGallery from "./components/pages/BoosterGallery.vue";
import ProductGallery from "./components/pages/ProductGallery.vue";
import Fishy from "./components/pages/Fishing.vue";
import CardFight from "./components/pages/CardFight.vue";
import Marketplace from "./components/pages/Marketplace.vue";
import MarketplaceCard from "./components/pages/MarketplaceCard.vue";
import LeaderBoard from "./components/pages/LeaderBoard.vue";
import Decks from "./components/pages/Decks.vue";
import DeckBuilder from "./components/pages/DeckBuilder.vue";
import Trading from "./components/pages/Trading.vue";
import Quiz from "./components/pages/Quiz.vue";
import PokeWordle from "./components/pages/PokeWordle.vue";
import CardGrading from "./components/pages/CardGrading.vue";

const routes = [
    {
        alias: '/login',
        name: 'landing',
        component: Landing,
        meta: {
            title: 'Dipocaco',
        }
    },
    {
        alias: '/',
        name: 'app',
        component: DipocacoApp,
        meta: {
            title: 'Dipocaco',
        },
        children: [
            {
                path: '/home',
                name: 'dashboard',
                component: Dashboard,
                meta: {
                    title: 'Dipocaco',
                }
            },
            {
                path: '/demo',
                name: 'demo-dashboard',
                component: DemoDashboard,
                meta: {
                    title: 'Dipocaco',
                }
            },
            {
                path: '/inventory',
                name: 'inventory',
                component: Inventory,
                meta: {
                    title: 'Dipocaco | Inventory',
                }
            },
            {
                path: '/my-cards',
                name: 'my-cards',
                component: MyCards,
                meta: {
                    title: 'Dipocaco | Collection',
                }
            },
            {
                path: '/shop/:tab?/:filter?',
                name: 'shop',
                component: BoosterShop,
                meta: {
                    title: 'Dipocaco | Shop',
                }
            },
            {
                path: '/gallery/:tab?',
                name: 'gallery-list',
                params: {
                    set_id: {type: String}
                },
                component: GalleryList,
                meta: {
                    title: 'Dipocaco | Gallery',
                }
            },
            {
                path: '/gallery/:set_id',
                name: 'gallery',
                component: Gallery,
                meta: {
                    title: 'Dipocaco | Gallery',
                }
            },
            {
                path: '/search/:searchQuery?',
                name: 'card-search',
                component: CardSearch,
                meta: {
                    title: 'Dipocaco | Card search',
                }
            },
            {
                path: '/card/:card_id',
                name: 'card-detail',
                component: CardDetailView,
                meta: {
                    title: 'Dipocaco | Card detail view',
                }
            },
            {
                path: '/settings',
                name: 'settings',
                component: Settings,
                meta: {
                    title: 'Dipocaco | Settings',
                }
            },
            {
                path: '/manage',
                name: 'manage',
                component: Manage,
                meta: {
                    title: 'Dipocaco | Settings',
                }
            },
            {
                path: '/collections/:tab?/:filter?',
                name: 'collections',
                component: Collections,
                meta: {
                    title: 'Dipocaco | Collections',
                }
            },
            {
                path: '/collection/:collection_id',
                name: 'collection',
                component: Collection,
                meta: {
                    title: 'Dipocaco | Collection',
                }
            },
            {
                path: '/u/:username',
                name: 'user-profile',
                component: UserProfile,
                meta: {
                    title: 'Dipocaco | User-Profile',
                }
            },
            {
                path: '/social/:tab?',
                name: 'social-feed',
                component: SocialFeed,
                meta: {
                    title: 'Dipocaco | Social Feed',
                }
            },
            {
                path: '/slot',
                name: 'slot-machine',
                component: SlotMachine,
                meta: {
                    title: 'Dipocaco | Slot Machine',
                }
            },
            {
                path: '/card-roulette',
                name: 'card-roulette',
                component: CardRoulette,
                meta: {
                    title: 'Dipocaco | Card Roulette',
                }
            },
            {
                path: '/booster-gallery',
                name: 'booster-gallery',
                component: BoosterGallery,
                meta: {
                    title: 'Dipocaco | Booster Gallery',
                }
            },
            {
                path: '/product-gallery',
                name: 'product-gallery',
                component: ProductGallery,
                meta: {
                    title: 'Dipocaco | Product Gallery',
                }
            },
            {
                path: '/fishing',
                name: 'fishing',
                component: Fishy,
                meta: {
                    title: 'Dipocaco | Fishing',
                }
            },
            {
                path: '/fight',
                name: 'fight',
                component: CardFight,
                meta: {
                    title: 'Dipocaco | Fight',
                }
            },
            {
                path: '/marketplace/:tab?',
                name: 'marketplace',
                component: Marketplace,
                meta: {
                    title: 'Dipocaco | Marketplace',
                }
            },
            {
                path: '/marketplace/c/:card_id',
                name: 'marketplace-card',
                component: MarketplaceCard,
                meta: {
                    title: 'Dipocaco | Marketplace Card',
                }
            },
            {
                path: '/grading',
                name: 'grading',
                component: CardGrading,
                meta: {
                    title: 'Dipocaco | Grading',
                }
            },
            {
                path: '/leaderboard/',
                name: 'leaderboard',
                component: LeaderBoard,
                meta: {
                    title: 'Dipocaco | Marketplace Card',
                }
            },
            {
                path: '/decks/',
                name: 'decks',
                component: Decks,
                meta: {
                    title: 'Dipocaco | Decks',
                }
            },
            {
                path: '/decks/:user_deck_id?',
                name: 'deck-builder',
                component: DeckBuilder,
                meta: {
                    title: 'Dipocaco | DeckBuilder',
                }
            },
            {
                path: '/trading/:tab?/:user?/:card?',
                name: 'trading',
                component: Trading,
                meta: {
                    title: 'Dipocaco | Trading',
                }
            },
            {
                path: '/quiz',
                name: 'quiz',
                component: Quiz,
                meta: {
                    title: 'Dipocaco | Quiz',
                }
            },
            {
                path: '/pokewordle',
                name: 'pokewordle',
                component: PokeWordle,
                meta: {
                    title: 'Dipocaco | PokéWordle',
                }
            },
        ]
    },
];

export default createRouter({
    history: createWebHistory(),
    routes
})
